import React from 'react';
import { SingleBrand } from './home-brands';

const BrandThree = () => {
	return (
		<div
			className="brand-area section-pt-30 section-pb-65"
			data-anime="opacity:[0, 1]; translateY:[24, 0]; onview: true; delay: 300;"
		>
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-xl-10 col-12">
						<div className="brand__list">
							<SingleBrand img_1="wallet-01.png" img_2="wallet-01-light.png" />
							<SingleBrand img_1="wallet-02.png" img_2="wallet-02-light.png" />
							<SingleBrand img_1="wallet-03.png" img_2="wallet-03-light.png" />
							<SingleBrand img_1="wallet-04.png" img_2="wallet-04-light.png" />
							<SingleBrand img_1="wallet-05.png" img_2="wallet-05-light.png" />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default BrandThree;
